<template>
	<Modals :title="title" :display="display" @show="close" :fullMobile="true">
		<template #modal-content>
			<div class="customers-modal">
				<div class="results-toolbar results-toolbar--variant-one">
					<div class="results-toolbar__search">
						<Search
							variant="toggle-icons"
							:placeholder="placeholder"
							v-model.lazy="search"
						/>
					</div>
					<div class="results-toolbar__counter">
						<ResultCounter :counter="customersCount" />
					</div>
				</div>
				<CustomerList :customers="customersData"></CustomerList>
				<Spinner :processor="{ loading: loading }" />
				<NoResults v-if="!customers.length" />
			</div>
		</template>

		<template #modal-footer>
			<Button
				className="btn--primary"
				:btnClick="close"
				:labelText="'Close'"
			/>
		</template>
	</Modals>
</template>

<script>
import Button from '@/components/forms/button/button';
import Modals from '@/components/shells/modal/modals';
import Search from '@/components/forms/search/search';
import ResultCounter from '@/site-components/result-counter/result-counter';
import CustomerOptionsMixins from '@/mixins/customers/customer-options';
import { filterAndSortArray } from '@/utils/function';
import CustomerList from '@/sections/shared/customers-modal-list.vue';
import NoResults from '@/site-components/no-results/no-results';
import Spinner from '@/components/visual/spinner/spinner';
//constants
import { CUSTOMER_OPTIONS } from '@/sections/options/options-mutation-type';
import {
	MODULE_NAME as INTEGRATOR_MODULE,
	DEALERSHIPCOMPANIES,
	TOTAL_CUSTOMERS_COUNT
} from '@/sections/vendors/vendors-mutation-types.js';
import { mapGetters } from 'vuex';

export default {
	name: 'CustomerModal',
	mixins: [CustomerOptionsMixins],
	components: {
		Button,
		Modals,
		Search,
		ResultCounter,
		CustomerList,
		NoResults,
		Spinner
	},
	model: {
		prop: 'display',
		event: 'close'
	},
	props: {
		display: {
			type: Boolean,
			default: false
		},
		source: {
			type: Array,
			default: () => []
		},
		renderSource: {
			type: Boolean,
			default: false
		},
		placeholder: {
			type: String,
			default: 'Search clients'
		},
		title: {
			type: String,
			default: 'Clients'
		},
		apiCall: {
			type: Function,
			default: () => {}
		},
		successCustomerApi: {
			type: Boolean,
			default: false
		},
		loading: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			search: '',
			customersData: [],
			sourceData: []
		};
	},
	computed: {
		...mapGetters(INTEGRATOR_MODULE, [
			DEALERSHIPCOMPANIES,
			TOTAL_CUSTOMERS_COUNT
		]),

		customersCount() {
			return this.customersData.length;
		},
		customers() {
			if (this.renderSource && this.sourceData.length > 0) {
				return this.sourceData;
			}
			const { items } = this[CUSTOMER_OPTIONS];

			if (items) {
				return items.filter(item => {
					return this.sourceData.includes(item.value);
				});
			}

			return [];
		},
		showNoResults() {
			return this.customersData.length === 0;
		}
	},
	methods: {
		close() {
			this.cleanCustomerVariables();
			this.$emit('close', false);
		},
		filterCustomerBySearch(val) {
			let newVal = val.toLowerCase();
			if (!newVal) {
				this.customersData = [...this.customers];
				return;
			}
			let result = filterAndSortArray(
				this.customers,
				{
					value: newVal
				},
				null
			);

			this.customersData = [...result];
		},
		redirectToCustomer() {
			const self = this;
			self.cleanCustomerVariables();
			self.$router.push({
				name: `test`
			});
		},
		setCustomerData() {
			if (
				this.apiCall instanceof Function &&
				this.apiCall()?.length > 0
			) {
				this.sourceData = this.apiCall();
			} else {
				this.sourceData = this.source;
			}

			let list = [];
			if (this.customers.length) {
				list = [...this.customers];
			}
			this.customersData = list;
		},
		cleanCustomerVariables() {
			this.search = '';
			this.customersData = [];
			this.$store.dispatch('integrators/dealershipCompanies', {});
			this.$store.dispatch('integrators/totalCustomersCount', 0);
			this.$store.dispatch(
				'integrators/showDealershipCompaniesModal',
				false
			);
		}
	},
	watch: {
		display: {
			handler(val) {
				if (val) {
					this.setCustomerData();
				}
			}
		},
		search: {
			deep: true,
			handler(val) {
				if (
					this[DEALERSHIPCOMPANIES].totalCount >
					this[DEALERSHIPCOMPANIES].countPerPage
				) {
					this.$emit('customerSearch', val);
				} else {
					if (
						this[TOTAL_CUSTOMERS_COUNT] !=
						this[DEALERSHIPCOMPANIES].totalCount
					)
						this.$emit('customerSearch', val);
					else this.filterCustomerBySearch(val);
				}
			}
		},
		successCustomerApi: {
			deep: true,
			handler(val) {
				if (val) {
					this.setCustomerData();
				}
			}
		}
	}
};
</script>

<style lang="scss" scoped>
/**
    * 3P Vendor Manager - Vendor card - Customers Modal
    * Can use SCSS variables = TRUE
*/

::v-deep .modal {
	@include mq($from: md) {
		width: 390px;
	}
}

::v-deep .modal__body {
	overflow: initial;
}

::v-deep
	.results-toolbar.results-toolbar--variant-one
	.results-toolbar__search {
	@include mq($from: md) {
		width: 100%;
	}
}

.customers-modal {
	padding-bottom: $padding-md;
}
</style>
